document.addEventListener('turbolinks:load', () => {
  setTimeout(() => {
    $('.flash').fadeOut();
  }, 2000);
});
